import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import FileField from '../forms/file-field';
import ImageUpload from '../image-upload';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  image: {
    display: 'flex'
  },
  currentImage: {
    alignSelf: 'center'
  },
  clearImageButton: {
    padding: '2px 6px'
  },
  imageField: {
    flexGrow: 1,
    '&:not(:first-child)': {
      marginLeft: theme.spacing(2)
    }
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
}));

const IMAGES_BROKEN = true;

const EventFormImage = ({ disabled, forceTouched }) => {
  const {
    values: { currentImage },
    setFieldValue,
  } = useFormikContext();
  const classes = useStyles();

  return (
    <Fragment>
      <Typography variant="h2">Image</Typography>
      {IMAGES_BROKEN && (
        <Alert severity="info" className={classes.alert}>
          Image uploads are temporarily disabled.
        </Alert>
      )}
      <div className={classes.image}>
        {currentImage && (
          <div className={classes.currentImage}>
            <ImageUpload record={{ image: currentImage }} size="133x100iwe" />
            <div>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  setFieldValue('currentImage', null);
                }}
                size="small"
                className={classes.clearImageButton}
                disabled={disabled}
              >
                Clear Image
              </Button>
            </div>
          </div>
        )}
        <div className={classes.imageField}>
          <FileField
            name="image"
            label="Image (optional)"
            disabled={disabled || IMAGES_BROKEN}
            touched={forceTouched}
          />
        </div>
      </div>
    </Fragment>
  );
};

EventFormImage.propTypes = {
  disabled: PropTypes.bool.isRequired,
  forceTouched: PropTypes.bool.isRequired,
};

export default EventFormImage;
